import { createStore, applyMiddleware, compose } from 'redux';
import logger from 'redux-logger';
import rootReducer from './reducers';

const middlewareList = process.env.NODE_ENV === 'development' ? [logger] : [];

export const store = createStore(
    rootReducer,
    compose(applyMiddleware(...middlewareList)),
);
